import { useTranslation } from 'react-i18next';
import { Flex, Box } from 'reflexbox';

import { Title, Heading, Button } from '@treams/treams-ui';
import { InsightsIllustration } from '@treams/treams-icons';

export default function EngagementThankYou() {
	const { t } = useTranslation();

	return (
		<Flex
			alignItems="center"
			pt={5}
			justifyContent="center"
			textAlign="center"
			maxWidth={670}
			flexDirection="column"
		>
			<Title>{t('engagement.respond.thankYou.title')}</Title>
			<Box mt={4} mb={-4} size={320}>
				<img width="100%" src={InsightsIllustration} alt="" style={{ display: 'block' }} />
			</Box>
			<Heading mb={4}>{t('engagement.respond.thankYou.description')}</Heading>
			<Button title={t('engagement.respond.thankYou.continue')} link="/" />
		</Flex>
	);
}
